import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useMediaQuery, useTheme } from "@mui/material";
import {
  activeCardSx,
  cardDescriptionSx,
  cardTitleSx,
  getCardMarkSx,
  inactiveCardSx,
} from "./OntologySection.sx";
import { CardData } from "./OntologySection.config";

export interface OntologyCardProps {
  card: CardData;
  isActive: boolean;
  onClick: () => void;
}

export const OntologyCard = ({ card, isActive, onClick }: OntologyCardProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const shouldUseActiveStyles = isMobile || isActive;

  return (
    <Stack
      direction="column"
      justifyContent="space-between"
      onClick={onClick}
      sx={shouldUseActiveStyles ? activeCardSx : inactiveCardSx}
    >
      <Stack direction="row" spacing={2} justifyContent="space-between">
        {/* Card title */}
        <Stack gap="4px">
          {card.title.split(" ").map((word, index) => (
            <Typography sx={cardTitleSx} key={index}>
              {word}
            </Typography>
          ))}
        </Stack>
        {/* Icon with fade transition */}
        <Box
          component="img"
          src={card.iconSrc}
          alt=""
          sx={getCardMarkSx(shouldUseActiveStyles)}
        />
      </Stack>

      {/* Card description */}
      <Typography sx={cardDescriptionSx}>{card.description}</Typography>
    </Stack>
  );
};

